import React from "react";

function Me(){
  return(
    <section id="bio">
            <div className="w-full bg-base-200">
                <div className="card-body w-5/6 m-auto">
                    <h2 className="text-3xl">About me: </h2>
                    <p>
                    My Name is Krystopher Quintero. I am a beginner/intermediate programmer. Currently, I am seeking new job opportunities to further my knowledge and expand my experience in programming. I am open to working remotely, hybrid, or in-office. I work great in teams and I am a quick learner able to adapt to project needs. Please feel free to browse my website and leave an email for any available employment opportunities. Thank You! 
                    </p>
                </div>
            </div>
        </section>
  )
}


export default Me;